__turbopack_context__.v({
  "Container": "esOXyG_Container",
  "Description": "esOXyG_Description",
  "Icon": "esOXyG_Icon",
  "Image": "esOXyG_Image",
  "ImageContainer": "esOXyG_ImageContainer",
  "Label": "esOXyG_Label",
  "Links": "esOXyG_Links",
  "Root": "esOXyG_Root",
  "Text": "esOXyG_Text",
  "Title": "esOXyG_Title",
  "skeleton-loading": "esOXyG_skeleton-loading",
});
